export default __webpack_public_path__ + "static/media/REMERAYOGUI2.4f655583.jpg";